

interface PremiumLockProps {
  feature?: 'reportes' | 'contratos' | 'default';
}

export default function PremiumLock({ feature = 'default' }: PremiumLockProps) {

  const content = {
    reportes: {
      title: "Desbloquea los Reportes Avanzados",
      description: "Obtén información detallada sobre tus ingresos, ocupación y tendencias. Toma decisiones basadas en datos reales para hacer crecer tu negocio.",
      icon: "ri-bar-chart-grouped-line",
      benefits: [
        "Reportes de ingresos por día, semana y mes",
        "Análisis de ocupación en tiempo real",
        "Exportación a Excel y PDF",
        "Métricas clave de rendimiento (KPIs)"
      ]
    },
    contratos: {
      title: "Gestiona Contratos Mensuales",
      description: "Automatiza la facturación recurrente y gestiona los contratos de tus clientes fijos de manera profesional y sin esfuerzo.",
      icon: "ri-file-list-3-line",
      benefits: [
        "Creación de contratos personalizados",
        "Facturación recurrente automática",
        "Control de vencimientos y renovaciones",
        "Gestión de múltiples vehículos por contrato"
      ]
    },
    default: {
      title: "Todo esto lo tendras al momento de actualizar a un plan Parqium",
      description: "Esta funcionalidad está disponible exclusivamente en la versión completa de Parqium. Actualiza tu plan hoy mismo.",
      icon: "ri-vip-crown-line",
      benefits: [
        "Acceso ilimitado a todas las funciones",
        "Soporte prioritario 24/7",
        "Actualizaciones automáticas",
        "Sin límites de usuarios"
      ]
    }
  };

  const info = content[feature] || content.default;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8 animate-fade-in">
      <div className="w-24 h-24 bg-gradient-to-br from-amber-100 to-orange-100 rounded-full flex items-center justify-center mb-6 shadow-sm">
        <i className={`${info.icon} text-4xl text-orange-500`}></i>
      </div>
      
      <h2 className="text-3xl font-bold text-slate-800 mb-3">
        {info.title}
      </h2>
      
      <p className="text-slate-500 max-w-lg mb-8 text-lg">
        {info.description}
      </p>

      <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm max-w-md w-full mb-8 text-left">
        <h4 className="font-semibold text-slate-700 mb-4 flex items-center gap-2">
          <i className="ri-star-smile-line text-amber-500"></i>
          Beneficios incluidos:
        </h4>
        <ul className="space-y-3">
          {info.benefits.map((benefit, index) => (
            <li key={index} className="flex items-start gap-3 text-slate-600 text-sm">
              <i className="ri-checkbox-circle-fill text-teal-500 mt-0.5"></i>
              {benefit}
            </li>
          ))}
        </ul>
      </div>

      <button
        className="group relative px-8 py-4 bg-gradient-to-r from-slate-900 to-slate-800 text-white rounded-xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 overflow-hidden"
        onClick={() => {
            // Aquí podríamos abrir un modal de contacto o redirigir
            // Por ahora redirigimos a una página de contacto o mostramos alerta
            window.open('https://wa.me/573008515255?text=Hola,%20quiero%20más%20información%20sobre%20Parqium%20Premium', '_blank');
        }}
      >
        <div className="absolute inset-0 bg-white/20 group-hover:translate-x-full transition-transform duration-500 -skew-x-12 -translate-x-full"></div>
        <span className="relative flex items-center gap-2 font-bold text-lg">
          <i className="ri-vip-crown-fill text-amber-400"></i>
          Contratar Plan
        </span>
      </button>

      <p className="mt-4 text-xs text-slate-400">
        ¿Ya tienes un plan? <span className="text-teal-600 font-medium cursor-pointer hover:underline" onClick={() => window.location.reload()}>Recargar página</span>
      </p>
    </div>
  );
}
